import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { StatusIconComponent } from "./status-icon/status-icon";

@NgModule({
  declarations: [StatusIconComponent],
  imports: [CommonModule],
  exports: [StatusIconComponent],
})
export class OnlineStatusModule {}



// WEBPACK FOOTER //
// ./src/providers/online-status/online-status.module.ts